// styles
import "./App.css";

import React from "react";
import { Route, Router, Switch } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";

import UserProvider from "./auth/UserProvider";
import Privacy from "./components/content/Privacy";
import { theme } from "./components/shared/styles";
import history from "./utils/history";
// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
import LoginPage from "./views/Authentication/LogInPage";
import SignUpPage from "./views/Authentication/SignUpPage";
import ExternalApi from "./views/ExternalApi";
import Generator from "./views/Generator";
import Home from "./views/Home";
import Profile from "./views/Profile";
import Templates from "./views/Templates";

initFontAwesome();

export const Content = styled.div`
  width: 100%;
  // margin: 112px auto 0 auto;
  margin: 0px auto 0 auto;
  display: flex;
  flex-direction: column;
`;

const ContentWrap = () => {
  return (
    <Router history={history}>
      <ThemeProvider theme={theme}>
        <div id="app">
          <Content>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/profile" component={Profile} />
              <Route path="/external-api" component={ExternalApi} />
              <Route path="/privacy" component={Privacy} />
              <Route path="/" exact component={Home} />
              <Route path="/profile" component={Profile} />
              <Route path="/external-api" component={ExternalApi} />
              <Route path="/privacy" component={Privacy} />
              <Route path="/login" component={LoginPage} />
              <Route path="/signup" component={SignUpPage} />
              <Route path="/templates" component={Templates} />
              <Route path="/generators" component={Generator} />
            </Switch>
          </Content>
          {/* <Footer /> */}
        </div>
      </ThemeProvider>
    </Router>
  );
};

const App = () => {
  // if (error) {
  //   return <div>Oops... {error.message}</div>;
  // }

  // if (isLoading) {
  //   return <Loading />;
  // }

  return (
    <UserProvider>
      <ContentWrap />
    </UserProvider>
  );
};
export default App;
